<template>
  <v-app>
    <header class="navbar">
      <TheNavbar />
    </header>

    <v-content>
      <TheContent />
    </v-content>

    <v-footer height="auto">
      <TheFooter />
    </v-footer>
  </v-app>
</template>

<script>
import TheNavbar from '@/components/navigation/TheNavbar.vue';
import TheContent from '@/components/TheContent.vue';
import TheFooter from '@/components/navigation/TheFooter.vue';

export default {
  name: 'BRIAppMobile',
  components: {
    TheNavbar,
    TheContent,
    TheFooter,
  },
};
</script>

<style lang="stylus">
@import 'assets/styles/main.styl';
</style>
